import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminAmazonImport from "@/pages/admin/AdminAmazonImport";

export const Route = createFileRoute("/admin/amazon-import")({
  component: () => (
    <ProtectedRoute>
      <AdminAmazonImport />
    </ProtectedRoute>
  ),
});
